import { Injectable } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CreateDataFeedSharedService {
    private fieldNameChanged = new Subject<any>();
    private dataTypeChanged = new Subject<any>();
    private primaryKeyChanged = new Subject<any>();
    private activeChanged = new Subject<any>();

    fieldNameChanged$ = this.fieldNameChanged.asObservable();
    dataTypeChanged$ = this.dataTypeChanged.asObservable();
    primaryKeyChanged$ = this.primaryKeyChanged.asObservable();
    activeChanged$ = this.activeChanged.asObservable();

    publishFieldNameDataChange(data: ICellRendererParams) {
        this.fieldNameChanged.next(data);
    }

    publishDataTypeChanged(data: ICellRendererParams) {
        this.dataTypeChanged.next(data);
    }

    publishPrimaryKeyChanged(data: ICellRendererParams) {
        this.primaryKeyChanged.next(data);
    }

    publishActiveChanged(data: ICellRendererParams) {
        this.activeChanged.next(data);
    }
}
